// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2LqPb","verify":"styles_verify__22jU-","actions":"styles_actions__2ozxI","action":"styles_action__3y2my"};